import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'
import { addBlankGroup } from 'partner360/features/assortment/assortmentSlice'
import { selectAssortmentGroupsData } from 'partner360/features/assortment/selectors'

import { TRANSLATION_KEYS } from '../../translations'

import { IAddAssortmentGroupProps } from './models'

import styles from './AddAssortmentGroup.module.scss'

export const AddAssortmentGroup: FC<IAddAssortmentGroupProps> = ({
  fYear,
  partnerId,
  programType,
  category,
}) => {
  const dispatch = useAppDispatch()

  const groups = useSelector(selectAssortmentGroupsData)

  const hasBlankGroup = useMemo(() => {
    return groups.some((group) => group.EntryId < 0)
  }, [groups])

  const addNewCard = useCallback(() => {
    dispatch(
      addBlankGroup({
        fYear,
        partnerId,
        programType,
        category,
      })
    )
  }, [dispatch, fYear, partnerId, programType, category])

  return (
    <Tooltip tipContent={() => <Translation span text={TRANSLATION_KEYS.group.addGroup} />}>
      <Button disabled={hasBlankGroup} className={styles.button} onClick={addNewCard}>
        <div className={styles.content}>
          <div className={styles.crossIcon}>
            <i className="kbase kbase-add" />
          </div>
          <div className={styles.message}>
            <Translation span text={TRANSLATION_KEYS.group.addGroup} />
          </div>
        </div>
      </Button>
    </Tooltip>
  )
}
